import styled from 'styled-components'

import { BulletedListItemStyled } from '../components/ListItem/styles/BulletedListItemStyled'

interface IBulletedListStyledProps {}

export const BulletedListStyled = styled.ul<IBulletedListStyledProps>`
  padding-left: ${(props) => props.theme.space.medium};
  list-style-type: disc;

  ${BulletedListItemStyled} + ${BulletedListItemStyled} {
    margin-top: ${(props) => props.theme.space.small};
  }
`
